// So sánh 2 version pack theo SemVer 2.0.0 §11 để phát hiện HẠ CẤP (ticket #191).
//
// Background:
//   `avatar sync` trần luôn kéo bản stable mới nhất. Máy đang cài bản beta MỚI HƠN
//   (vd v1.1.41-beta.0) chạy `avatar sync` sẽ bị đưa về stable cũ hơn (v1.1.40) mà
//   KHÔNG có dấu hiệu nào. Module này chỉ PHÂN LOẠI chuyển version; caller
//   (`src/commands/sync.ts`) quyết định in cảnh báo — hành vi mặc định không đổi.
//
// Bộ so SemVer §11 (prerelease, parse fail-soft) nằm ở
// `compare-semver-with-prerelease.ts`, dùng chung với cổng update CLI (F-18).
// Module này chỉ giữ phần PHÂN LOẠI chuyển version của pack.

import { compareParsedSemVer, parseSemVerLoose } from "./compare-semver-with-prerelease.js";

export type PackVersionTransition = "upgrade" | "noop" | "downgrade" | "unknown";

// Phân loại chuyển version: bản ĐANG CÀI (`current`) → bản SẮP CÀI (`target`).
//
// `current` lớn hơn `target` ⇒ "downgrade" (đây là ca #191 cần cảnh báo).
// Bất kỳ phía nào không đọc được (chưa cài, `local:/path`, `local-2026-08-11`,
// `+build`, rỗng, null) ⇒ "unknown" — caller phải IM LẶNG, không đoán.
export function classifyPackVersionTransition(
  current: string | null | undefined,
  target: string | null | undefined,
): PackVersionTransition {
  const parsedCurrent = parseSemVerLoose(current);
  const parsedTarget = parseSemVerLoose(target);
  if (parsedCurrent === null || parsedTarget === null) return "unknown";

  const comparison = compareParsedSemVer(parsedCurrent, parsedTarget);
  if (comparison === 0) return "noop";
  return comparison < 0 ? "upgrade" : "downgrade";
}
